import { useState } from "react";
import axios from "axios";
import { RefreshCw, Tags } from "lucide-react";
import { toast } from "sonner";
import { EmailInboxPage } from "./EmailInboxPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailInboxPageV2 = () => {
  const [checking, setChecking] = useState(false);
  const [lastResult, setLastResult] = useState(null);

  const checkBallStatusUpdates = async () => {
    setChecking(true);
    try {
      const response = await axios.post(`${API}/email/ball-status/poll`);
      setLastResult(response.data);
      const matched = response.data?.matched || 0;
      const unmatched = response.data?.unmatched || 0;
      toast.success(`Ball status check complete: ${matched} updated, ${unmatched} unmatched`);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Ball status email check failed");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="space-y-6">
      <section className="rounded-xl border border-border bg-card p-5">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 font-semibold">
              <Tags size={18} />
              Ball Graphics Status Automation
            </h2>
            <p className="mt-1 text-sm text-muted-foreground">
              Recognized emails from BallGraphics@Ball.com update interim status tags and workflow phases on matching projects.
            </p>
            {lastResult && (
              <p className="mt-2 text-xs text-muted-foreground">
                Last manual check: {lastResult.matched || 0} updated, {lastResult.unmatched || 0} unmatched.
              </p>
            )}
          </div>
          <button
            type="button"
            onClick={checkBallStatusUpdates}
            disabled={checking}
            className="inline-flex items-center gap-2 rounded-lg bg-secondary px-4 py-2.5 text-sm font-medium disabled:opacity-50"
          >
            <RefreshCw size={16} className={checking ? "animate-spin" : ""} />
            {checking ? "Checking..." : "Check Ball Status Updates"}
          </button>
        </div>
      </section>
      <EmailInboxPage />
    </div>
  );
};
